// extracted by mini-css-extract-plugin
export default {"container":"styles_container__mWihY","card":"styles_card__m-Q4R","col":"styles_col__U69fg"};